module.exports = __webpack_public_path__ + "img/o4.4f663045.png";